import TagsListUnaffectedManager from './TagsListUnaffectedManager'

export default TagsListUnaffectedManager
